export const PSIRF_TYPES = {
  TOP_SECTION: 'TopSection',
  SUMMARY: 'Summary',
  LEARNING: 'Learning',
  EXTENDED_LEARNING: 'ExtendedLearning',
  QUICK_WATCH: 'QuickWatch',
  KEY_POINTS: 'KeyPoints',
  REFLECTIVE_QUESTIONS: 'ReflectiveQuestions',
  FURTHER_READING: 'FurtherReading',
  QUIZ: 'Quiz',
  USEFUL_LINKS: 'UsefulLinks',
  ACKNOWLEDGMENT: 'Acknowledgment',
  UP_TICKS: 'upTicks',
};
